<template>
 <headers />
  <div class="info">
  <div id="main" :style="{ width: '1200px', height: '800px' }"></div>
  </div>
</template>
<style>
.info {
  width: 98%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 50px;
}
</style>
<script>
import headers from "../views/Home.vue";
import * as echarts from "echarts";
export default {
  components: {
    headers,
  },
  setup() {
    setTimeout(function () {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "某站点用户访问来源",
          subtext: "纯属虚构",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "搜索引擎" },
              { value: 735, name: "直接访问" },
              { value: 580, name: "邮件营销" },
              { value: 484, name: "联盟广告" },
              { value: 300, name: "视频广告" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    }, 200);
  },
};
</script>